function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#fdd020"
}, /*#__PURE__*/React.createElement("path", {
  d: "m416.121094 160.0625c0 57.4375-46.558594 104-104 104-57.4375 0-104-46.5625-104-104s46.5625-104 104-104c57.441406 0 104 46.5625 104 104zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m464.121094 168.0625h-16c-4.417969 0-8-3.582031-8-8s3.582031-8 8-8h16c4.421875 0 8 3.582031 8 8s-3.578125 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m296.121094 32.0625c-4.417969 0-8-3.582031-8-8v-16c0-4.417969 3.582031-8 8-8 4.421875 0 8 3.582031 8 8v16c0 4.417969-3.578125 8-8 8zm0 0"
}), /*#__PURE__*/React.createElement("path", {
  d: "m408.121094 72.0625c-3.234375 0-6.148438-1.949219-7.386719-4.941406-1.238281-2.988282-.554687-6.425782 1.734375-8.714844l16-16c2.007812-2.082031 4.980469-2.914062 7.777344-2.183594 2.796875.734375 4.980468 2.917969 5.714844 5.714844.730468 2.796875-.101563 5.769531-2.183594 7.78125l-16 16c-1.5 1.5-3.53125 2.34375-5.65625 2.34375zm0 0"
}));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m363.15625 360.0625c30.167969.722656 58.359375-14.957031 73.660156-40.96875 15.296875-26.015625 15.296875-58.273438 0-84.289062-15.300781-26.011719-43.492187-41.691407-73.660156-40.96875-5.640625.003906-11.269531.554687-16.800781 1.648437-6.925781-32.023437-35.375-54.789063-68.136719-54.535156-10.015625.003906-19.917969 2.144531-29.039062 6.28125-16.066407-41.289063-59.042969-65.5-102.679688-57.84375s-75.804688 45.046875-76.855469 89.339843c.019531 10.351563 1.855469 20.617188 5.421875 30.335938-27.144531.160156-52.113281 14.875-65.402344 38.546875-13.285156 23.671875-12.847656 52.652344 1.15625 75.910156 14 23.253907 39.40625 37.207031 66.542969 36.542969",
  fill: "#a3d4f7"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m328.121094 392.0625c0 17.671875-14.324219 32-32 32-17.671875 0-32-14.328125-32-32 0-24 32-80 32-80s32 56 32 80zm0 0",
  fill: "#60a2d7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m248.121094 312.0625c0 17.671875-14.324219 32-32 32-17.671875 0-32-14.328125-32-32 0-24 32-80 32-80s32 56 32 80zm0 0",
  fill: "#60a2d7"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m176.121094 408.0625c0 17.671875-14.324219 32-32 32-17.671875 0-32-14.328125-32-32 0-24 32-80 32-80s32 56 32 80zm0 0",
  fill: "#60a2d7"
});

var SvgRainyDay = function SvgRainyDay(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "472pt",
    viewBox: "0 -16 472.12294 472",
    width: "472pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRainyDay, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rainy-day.418c454c.svg";
export { ForwardRef as ReactComponent };